import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { Modal as InstModal } from '@instructure/ui-modal';
import liveRegion from '../../alertHelpers';

// NOTE: This Modal should only be used on pages where Learnosity calculator can not be opened
// because the calculator hides the Modal which provides bad user experience.
// If you need a Modal to hide the calculator use the ImportantModal component.
export var Modal = /*#__PURE__*/function (_Component) {
  function Modal() {
    _classCallCheck(this, Modal);
    return _callSuper(this, Modal, arguments);
  }
  _inherits(Modal, _Component);
  return _createClass(Modal, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(InstModal, Object.assign({
        liveRegion: liveRegion
      }, this.props));
    }
  }]);
}(Component);
export default Modal;